import { render } from "./SearchVendor.vue?vue&type=template&id=19f364d0&scoped=true"
import script from "./SearchVendor.vue?vue&type=script&lang=js"
export * from "./SearchVendor.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=19f364d0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f364d0"]])

export default __exports__